document.addEventListener('turbo:load', () => {
  // --------------------------------------------------------------------------
  // Dropdown
  function toggleDropdown($el) {
    $el.classList.toggle('is-active');
  }

  // Close all dropdowns
  function closeAllDropdowns() {
    document.querySelectorAll('.dropdown.is-active').forEach(($dropdown) => {
      $dropdown.classList.remove('is-active');
    });
  }

  // Add a click event on the dropdown trigger to toggle the dropdown
  document.querySelectorAll('.dropdown-trigger').forEach(($trigger) => {
    const $dropdown = $trigger.closest('.dropdown');

    $trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      closeAllDropdowns();
      toggleDropdown($dropdown);
    });
  });

  // Close dropdowns if clicking outside
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.dropdown')) {
      closeAllDropdowns();
    }
  });

  // Close dropdown on "Escape" key
  document.addEventListener('keydown', (event) => {
    if (event.key === "Escape") {
      closeAllDropdowns();
    }
  });

  // --------------------------------------------------------------------------
  // Modal
  function openModal($el) {
    $el.classList.add('is-active');
  }

  function closeModal($el) {
    $el.classList.remove('is-active');
  }

  function closeAllModals() {
    (document.querySelectorAll('.modal') || []).forEach(($modal) => {
      closeModal($modal);
    });
  }

  // Add a click event on buttons to open a specific modal
  (document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger) => {
    const modal = $trigger.dataset.target;
    const $target = document.getElementById(modal);

    $trigger.addEventListener('click', () => {
      openModal($target);
    });
  });

  // Add a click event on various child elements to close the parent modal
  (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close) => {
    const $target = $close.closest('.modal');

    $close.addEventListener('click', () => {
      closeModal($target);
    });
  });

  // Add a keyboard event to close all modals
  document.addEventListener('keydown', (event) => {
    if(event.key === "Escape") {
      closeAllModals();
    }
  });

  // --------------------------------------------------------------------------
  // Nav
  setTimeout(() => {
    const navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)

    // Add a click event on each of them
    navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {
        // Get the target from the "data-target" attribute
        const target = el.dataset.target
        const $target = document.getElementById(target)

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active')
        $target.classList.toggle('is-active')
      })
    })
  }, 500)

  // --------------------------------------------------------------------------
  // Notification
  setTimeout(() => {
    (document.querySelectorAll('.notification .delete') || []).forEach(($delete) => {
      const $notification = $delete.parentNode
  
      $delete.addEventListener('click', () => {
        $notification.parentNode.removeChild($notification)
      })
    })
  }, 1000)
})